<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" style="margin-left: -45px;">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="정산년월" label-width="120px">
                <el-col :span="10">
                  <el-select v-model="form.years">
                    <el-option
                        v-for="item in combos['years']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="10">
                  <el-select v-model="form.months">
                  <el-option
                      v-for="item in combos['months']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-col>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="지역/센터" label-width="120px">
                <el-col :span="8">
                  <el-select v-model="form.catId" @change="onCatIdChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['catId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['subCatId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="정산구분" label-width="120px">
                <el-select v-model="form.squareYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['squareYn']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixin/lucoms";
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import CalculationListModal from '@/components/LucomsModal/CalculationListModal.vue';

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [mixin],
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        years : this.$moment().format('YYYY'),
        months : this.$moment().format('MM'),
        squareYymm : '',
        companyId : '',
        squareYn : '',              // 정산구분
        catId : '',                 // 지역/센터
        subCatId : '',
        sortType :  '',
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'years' : [],
        'months' : [],
        'catId' : [],
        'squareYn' : [],
        'subCatId' : [],
      },
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeCatIdShow : false
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      const that = this
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          pinned: 'left',
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'센터명', field:'asAgentNm', width:130, cellStyle:{textAlign: 'left'}, pinned: 'left',
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'정산구분', field:'squareYnNm', width:110, cellStyle:{textAlign: 'center'}, pinned: 'left'},
        {
          headerName: 'A/S',
            children: [
              {
                headerName: '유상',
                children: [
                  {headerName:'자재비', field:'inAsItemUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'이관비', field:'inAsCallUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'대수', field:'inAsQty', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'합계', field:'inAsAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                ]
              },
              {
                headerName: '무상',
                children: [
                  {headerName:'기본비', field:'outAsUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'원거리출장비', field:'outAsEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'기타비용', field:'outAsEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'대수', field:'outAsQty', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                  {headerName:'합계', field:'outAsAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.getNumberFormat(params.value);
                    }},
                ]
              }
          ],
        },
        {
          headerName: 'BS/MA',
              children: [
                {headerName:'처리비', field:'outBsmaUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'원거리출장비', field:'outBsmaEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'기타비용', field:'outBsmaEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'대수', field:'outBsmaQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'합계', field:'outBsmaAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
              ]
            },
            {
              headerName: '설치',
              children: [
                {headerName:'설치비1', field:'outSetupUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'설치비2', field:'outSetupUnitPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'원거리출장비', field:'outSetupEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'기타비용', field:'outSetupEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
                {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.getNumberFormat(params.value);
                  }},
          ],
        },
        {
          headerName: '합계',
          children: [
            {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return that.getNumberFormat(params.value);
              }},
            {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return that.getNumberFormat(params.value);
              }},
          ]
        }
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'asAgentNm') {
        this.openModel(params.data);
      }
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 1200,
        component: CalculationListModal,
        parent: this,
        props: {
          data: {
            asAgentId: param.asAgentId
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this
      console.log('goOpen passed ')
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/calculation/list"), {
        companyId : this.form.companyId,
        squareYymm : this.form.years + this.form.months,
        squareYn : this.form.squareYn,          // 정산구분
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId, // 지역
        sortType :  '',
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      }).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/calculation/init`)
          .then(response => {
            this.combos['years'] = response.data.years;
            this.combos['months'] = response.data.months;
            this.combos['catId'] = response.data.catId;
            this.combos['squareYn'] = response.data.squareYn;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>